// --- HELPER: Convert File to Base64 ---
export const fileToBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

// --- HELPER: Open Base64 Image in New Tab ---
export const openImageInNewTab = (e, base64String) => {
  e.preventDefault(); // Stop the <a> tag from doing its default blocked behavior
  
  if (!base64String) return;
  
  // If it's already a standard URL, just open it normally
  if (!base64String.startsWith('data:')) {
      window.open(base64String, '_blank');
      return;
  }

  // Convert Base64 to a Blob, create a safe local URL, and open it
  fetch(base64String)
    .then(res => res.blob())
    .then(blob => {
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    })
    .catch(err => console.error("Error opening image:", err));
};

// --- HELPER: Compress Image using HTML5 Canvas ---
export const compressImageToCanvas = (file, maxSizeMB = 1) => {
  return new Promise((resolve, reject) => {
    const maxSize = maxSizeMB * 1024 * 1024;
    if (file.size <= maxSize) {
      // Just convert to base64 if it's already small enough
      return fileToBase64(file).then(resolve).catch(reject);
    }
    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Calculate new dimensions keeping aspect ratio (max 1600x1600)
        const maxDim = 1600;
        if (width > maxDim || height > maxDim) {
            if (width > height) {
                height = Math.round((height *= maxDim / width));
                width = maxDim;
            } else {
                width = Math.round((width *= maxDim / height));
                height = maxDim;
            }
        }
        
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Export to Base64 (JPEG format with 0.8 quality)
        resolve(canvas.toDataURL('image/jpeg', 0.8));
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};
